import { useDropdown } from '@/hooks/Dropdown-hook'
import { useAppSelector } from '@/store'
import { resetActivityData, setActivityFormData } from '@/store/slices/activitySlice'
import { ACTIVITY_TYPE } from '@/types/Activity'
import { DROPDOWN_TYPES } from '@/utils/constants/dropdownConstants'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const useActivitySetup = () => {
  const dispatch = useDispatch()
  const activityTypes = useSelector(state => state.activity.activityTypes)
  const activityFormData = useAppSelector(state => state.activity.formData) // for Edit

  const [formData, setFormData] = useState(activityFormData)
  const { dropdownList, isLoading } = useDropdown({ dropdownType: DROPDOWN_TYPES.ActivitiesType })
  const [activityDropdownTypes, setActivityDropdownTypes] = useState({})

  const handleFormChange = data => {
    if (data?.hasEndDate === false && data.activityType === ACTIVITY_TYPE.WELCOME_ACTIVITY) {
      delete data.endDate
      delete data.endDateValid
      setFormData(data)
      return
    }
    setFormData(prev => ({ ...prev, ...data }))
  }
  useEffect(() => {
    dispatch(setActivityFormData(formData))
  }, [formData, dispatch])

    const handleResetFormData = data => {
    const defaultFormData = {
      activityType: data?.activityType,
      hasEndDate: false,
      uuid: data?.uuid || '',
      id: data?.id || '', // Preserve the id
    }
    setFormData(defaultFormData)
    dispatch(resetActivityData(defaultFormData))
  }

  useEffect(() => {
    // append dropdown data to activityTypes
    if (dropdownList?.length > 0) {
      let updatedDropdownData = JSON.parse(JSON.stringify(activityTypes))
      updatedDropdownData.properties.activityType.options = [...dropdownList]
      setActivityDropdownTypes(updatedDropdownData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownList])

  return {
    formData,
    activityTypes,
    handleFormChange,
    dropdownList,
    activityDropdownTypes,
    handleResetFormData,
    isLoading,
  }
}

export default useActivitySetup
